import LegalLayout from "@/components/LegalLayout";
import { Sparkles, Eye, HeartHandshake, Hammer, Mail } from "lucide-react";

export default function About() {
    const pillars = [
        { icon: Hammer, title: "Ready-to-Cut CNC Files", desc: "Our library boasts an extensive collection of CNC design files that are meticulously crafted and optimized for seamless cutting. No more hassles or delays — simply download, and you're ready to cut." },
        { icon: Sparkles, title: "Top-Level Designs", desc: "At FilesCAD, we understand the importance of precision and creativity. Our team of skilled designers is committed to bringing you top-tier designs that stand out and elevate your CNC projects to new heights." },
        { icon: Eye, title: "Full HD Previews", desc: "We believe in transparency. With our full HD previews, you can inspect every intricate detail of the design before making any commitments. This ensures that you get exactly what you envision for your CNC project." },
        { icon: HeartHandshake, title: "Best Customer Support", desc: "Your satisfaction is our priority. Our dedicated customer support team is always ready to assist you with any inquiries, concerns, or assistance you may need." },
    ];

    return (
        <LegalLayout testId="about-page" title="About Us">
            <p className="text-xl text-slate-700 leading-relaxed">
                Welcome to FilesCAD. Established in 2020, we have been at the forefront of providing top-tier CNC design files that are ready to cut. We take pride in offering a diverse range of high-quality designs to cater to your CNC machining needs.
            </p>
            <p>
                As a cutting-edge platform, we strive to bring you the best in top-level designs with a full HD preview — ensuring you have a crystal-clear vision of your project before making any cuts.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-12 mb-6">Why choose FilesCAD?</h3>
            <div className="not-prose grid grid-cols-1 md:grid-cols-2 gap-5">
                {pillars.map((p, i) => (
                    <div
                        key={p.title}
                        data-testid={`about-pillar-${i}`}
                        className="rounded-2xl border border-slate-200 p-6 bg-white hover:border-slate-900 transition-colors"
                    >
                        <div className="w-11 h-11 rounded-xl bg-slate-950 grid place-items-center mb-4">
                            <p.icon className="w-5 h-5 text-white" />
                        </div>
                        <h4 className="font-display font-bold text-lg text-slate-950">{p.title}</h4>
                        <p className="mt-2 text-slate-600 text-sm leading-relaxed">{p.desc}</p>
                    </div>
                ))}
            </div>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-12">Contact</h3>
            <p className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-600" />
                <a
                    href="mailto:support@filescad.com"
                    data-testid="about-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>
        </LegalLayout>
    );
}
